import React from "react"
import { OutboundLink } from 'gatsby-plugin-google-gtag'
import cardlinkStyles from "./cardlink.module.css"

export default props => (
  <OutboundLink className={cardlinkStyles.cardlink} href={props.href} target="_blank" rel="noopener">{props.linkText}</OutboundLink>
)